import * as $ from "jquery";

export class EnrollPaymentType {
    $paymenttype: JQuery;
    $paymentccoption: JQuery;
    $paymentnonccoption: JQuery;
    $paymenttypeoffice: JQuery;

    constructor() {
        this.$paymenttype = $("#PaymentType");
        this.$paymentccoption = $(".paymentccoption");
        this.$paymentnonccoption = $(".paymentnonccoption");
        this.$paymenttypeoffice = $("#PaymentTypeOffice");

        const self = this;

        this.$paymenttype.on("change", function (evt) {
            //console.log("DD changed");
            self.updateDD();
        });

        this.updateDD();
    }

    updateDD() {
        const radioValue = <string>this.$paymenttype.val();
        this.$paymenttypeoffice.val(radioValue);
        if (radioValue) {
            if (radioValue === "11") { // CC
                this.$paymentccoption.show();
                this.$paymentnonccoption.hide();
            } else {
                this.$paymentccoption.hide();
                this.$paymentnonccoption.show();
            }
        } else {
            this.$paymentccoption.hide();
            this.$paymentnonccoption.hide();
        }
    }
}
